import * as Moment from "moment"
import * as React from "react"
import { slugify } from "../../custom_utils/helpers"


export type TippedTeaserContentProps = {
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  title: string,
  isTip?: boolean,
  label?: string | JSX.Element,
  imageAlt?: string,
  imageUrl?: string,
  videoUrl?: string,
  intro?: string,
  location: JSX.Element | string
  date: Date
}

export const TippedTeaserContent = (p: TippedTeaserContentProps) => {
  const Heading = p.headingLevel;
  return (
    <article className="teaser__inner">
      <header className="teaser__header">
        <Heading className="teaser__title title--m" id={`a11y-teaser-title-${slugify(p.title)}`}>
          <span dangerouslySetInnerHTML={{ __html: p.title }} />
        </Heading>
        <div className="teaser__meta text--s">
          <time className="teaser__meta-item teaser__date" dateTime={Moment(p.date).format('L')}>
            <span className="icon-calendar" aria-hidden="true"></span>
            {Moment(p.date).format("dd D MMMM")}
          </time>
          <span className="teaser__meta-item teaser__location">
            <span className="icon-map-pin" aria-hidden="true"></span>
            {p.location}
          </span>
        </div>       
      </header>
      
      <div className="teaser__content">
        {p.intro && <p className="teaser__intro" dangerouslySetInnerHTML={{ __html: p.intro }} />}
        {p.imageUrl && (
          <div className="teaser__visual">
            {p.label && <div className="teaser__label">{p.label}</div>}
            <img src={p.imageUrl} alt={p.imageAlt} className="teaser__image" />
          </div>
        )}
        {p.videoUrl && (
          <div>
            <figure className="block block--video block--video--no-margin">
              <iframe key="iframe" className="block__iframe" src={p.videoUrl} frameBorder="0" title={p.title} />
            </figure>
          </div>
        )}
      </div>
      

      <footer className="teaser__fauxlink">
        <svg className="teaser__fauxlink-icon" width="8px" height="14px" aria-hidden="true"><use xlinkHref="#icon--chevron-right"></use></svg>
        <span>Bekijk activiteit</span>
      </footer>
    </article>
  )
}
